export const ERC20ABI = [
  'function name() public view returns (string)',
  'function decimals() view returns (uint32)',
  'function symbol() view returns (string)'
];
